module.exports = __webpack_public_path__ + "static/Horizontal_Business_Partner_Badge-5acaf337ac0fbf489139da9c9734dfff.png";